/**
 * 演示环境模块接口列表
 */
import $http from '../utils/http';
//查询监控模块

const environmentalRestoration = {
  restore(id ,params) {
  let param = new URLSearchParams();
  param.append(id, params);
  return $http.post(`${global.API_URL}/sme/restoration/restore`, param);
}
}
export default environmentalRestoration;



// WEBPACK FOOTER //
// ./src/api/environmentalRestoration.js